import React from 'react'

import { DataAttribute } from '@frame/types'

export function RequiredTag() {
  return (
    <div
      data-cy={DataAttribute.LABEL_TAG}
      className="pointer-events-none ml-1 inline text-base font-semibold text-error-600"
    >
      *
    </div>
  )
}

export function OptionalTag() {
  return (
    <div
      data-cy={DataAttribute.LABEL_TAG}
      className="pointer-events-none ml-2 inline rounded-[4px] bg-moss-200 px-1 py-[2px] text-xs font-medium"
    >
      Optional
    </div>
  )
}

export function RecommendedTag() {
  return (
    <div
      data-cy={DataAttribute.LABEL_TAG}
      className="pointer-events-none ml-2 inline rounded-[4px] bg-electric-200 px-1 py-[2px] text-xs font-medium text-electric-650"
    >
      Recommended
    </div>
  )
}
